// src/modulos/Dashboard/dashboards/TUVDashboard.js
import React from 'react';
import styles from './TUV.module.css';

/**
 * TUVDashboard - Dashboard for Technical, User and Vendor domains
 * 
 * CURRENT STATUS: Under Development
 */
const TUVDashboard = ({ user = { name: 'Usuário TUV', role: 'Coordenador' } }) => {
    return (
        <div className={styles.tuvContainer}>

            {/* Under Development Card */}
            <div className={styles.underDevelopmentCard}>
                <div className={styles.underDevIcon}>🚧</div>
                <h2 className={styles.underDevTitle}>Em Desenvolvimento</h2>
                <p className={styles.underDevMessage}>
                    Estamos trabalhando para trazer um dashboard completo e integrado para os domínios<br />
                    de Tecnologia, Experiência do Usuário e Gestão.
                </p>
                <div className={styles.underDevDetails}>
                    <div className={styles.underDevSection}>
                        <span className={styles.underDevSectionIcon}>📊</span>
                        <span>Métricas em tempo real</span>
                    </div>
                    <div className={styles.underDevSection}>
                        <span className={styles.underDevSectionIcon}>🔔</span>
                        <span>Alertas integrados</span>
                    </div>
                    <div className={styles.underDevSection}>
                        <span className={styles.underDevSectionIcon}>💡</span>
                        <span>Recomendações inteligentes</span>
                    </div>
                    <div className={styles.underDevSection}>
                        <span className={styles.underDevSectionIcon}>🔗</span>
                        <span>Visão macro</span>
                    </div>
                </div>
                <div className={styles.underDevApology}>
                    <p>Pedimos desculpas pelo inconveniente.</p>
                </div>
            </div>
        </div>
    );
};

export default TUVDashboard;